import { ReactNode, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { SxProps, Theme } from '@mui/material';
import { COLORS } from '../../theme';

const CollapsibleCard = ({
  title,
  content,
  sx = {},
  startExpanded = false,
  headerAction,
}: {
  title: string;
  content: ReactNode;
  sx?: SxProps<Theme>;
  startExpanded?: boolean;
  // Optional node shown in the header, to the left of the expand/collapse chevron.
  headerAction?: ReactNode;
}) => {
  const [expanded, setExpanded] = useState(startExpanded);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card
      sx={{
        border: `1px solid ${COLORS.gray[700]}`,
        borderRadius: '10px',
        cursor: 'pointer',
        ...sx,
      }}
      onClick={handleExpandClick}
    >
      <CardHeader
        titleTypographyProps={{ variant: 'body1', sx: { fontWeight: 600, fontSize: '18px' } }}
        title={title}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {headerAction}
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              sx={
                expanded
                  ? { transform: 'rotate(180deg)' }
                  : {
                      transform: 'rotate(0deg)',
                      transition: 'transform 0.2s',
                    }
              }
            >
              <ExpandMore />
            </IconButton>
          </Box>
        }
      />
      <Collapse in={expanded} unmountOnExit>
        <CardContent>{content}</CardContent>
      </Collapse>
    </Card>
  );
};

export default CollapsibleCard;
